(function($){
    'use strict';

    var $main = $('.main'),
    	$alert = $('.js-alert');

    if($alert.length) {
        var alertDate = $alert.attr('data-date'),
            alertCookie = getCookie('LCC-alert');

        if(alertCookie == null) { 
            showAlert();
        } else {
            if(alertCookie != alertDate) {
                showAlert();
            }
        }
    }

    function showAlert() {
        $alert.show();
        adjustTopSpace();

        $(window).resize(function() {
            adjustTopSpace();
        });

        $alert.find('button').click(function() {
            hideAlert();
        })
    }

    function hideAlert() {
        $alert.hide();
        adjustTopSpace();
        setCookie('LCC-alert', alertDate);
    }

    function adjustTopSpace() {
        if($alert.is(":visible")) {
            var alertHeight = $alert.outerHeight();
            $main.css('padding-top', alertHeight);
        } else {
            $main.css('padding-top', 0);
        }
    }

    function setCookie(name, value, days) {
        var expires = '';

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    
}(jQuery));